module.exports = __webpack_public_path__ + "annualreview2017/static/img/uk-map.ffb1230.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/uk-map.svg
// module id = 800
// module chunks = 0